export default {
  ru: {
    title: 'Выберите тип билета',
    entryTicket: 'Входной билет',
    excursionTicket: 'Билет на экскурсию',
    countTitle: 'Выберите количество билетов',
    sum: 'Стоимость покупки: <b>{sum}</b>',
    pay: 'Перейти к оплате',
    searchWord: 'билет',
    notPossible: 'На данный момент покупка билетов невозможна',
    badTime: 'Продажа осуществляется только в рабочее время',
    note: 'Если вы хотите приобрести льготный билет, пожалуйста, обратитесь в кассу',
    goHome: 'На главную',
    badConnection: 'Ошибка соединения',
  },
  en: {
    // en
  },
};
